<template>
  <div v-if="config" class="page">
    <HeaderTitle />
    <ActionBar
      :isEditing="isEditing"
      @changeAction="changeConfig"
      @cancelAction="cancelConfigChanges"
      @deleteAction="deleteConfig"
      @saveAction="updateConfig"
    />
    <br>
    <ConfigShow v-if="!isEditing" :config="config" />
    <ConfigEdit
      v-else
      :config="config"
      :configComponentDefinitions="configComponentDefinitions"
    />
  </div>
</template>

<script>

import Swal from 'sweetalert2'
import {mapActions, mapState} from 'vuex'
import ConfigsAPI from '../../api/configs'
import deepAssign from 'assign-deep'
import ConfigShow from './ConfigShow'
import ConfigEdit from './ConfigEdit'

export default {
  name: 'ConfigPage',
  components: {
    ConfigEdit,
    ConfigShow
  },
  props: {
    configId: {
      type: String,
      default: () => null
    }
  },
  data () {
    return {
      isEditing: false,
      config: null,
      prevConfig: null,
      isUpdating: false
    }
  },
  computed: {
    ...mapState('configs/configComponentDefinition', {
      configComponentDefinitions: state => state.items,
    }),
  },
  mounted () {
    this.loadData()
    this.loadItems()
  },
  methods: {
    ...mapActions('configs/configComponentDefinition', [
      'loadItems'
    ]),
    ...mapActions('configs/configs', [
      'abortLoading'
    ]),
    ...mapActions('taxi', [
      'setTitle'
    ]),
    loadData () {
      ConfigsAPI.getItem({
        id: this.configId,
      })
        .then(response => {
          this.config = response
          if (!response) {
            return false
          }
          this.setTitle([
            {
              title: 'Настройки',
              url: '/configs'
            }, {
              title: response.title ?? response.component_name
            }
          ])
        })
    },
    changeConfig () {
      this.prevConfig = deepAssign({}, this.config)
      this.isEditing = true
    },
    deleteConfig () {
      Swal.fire({
        icon: 'warning',
        title: 'Вы действительно хотите удалить конфиг?',
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonColor: '#c82333',
        cancelButtonText: 'Отменить',
        confirmButtonText: 'Удалить'
      }).then(event => {
        if (event.value) {
          ConfigsAPI.removeItem(this.config.id)
            .then(() => {
              this.$router.push('/configs')
            })
            .catch(err => {
              console.error(err)
              Swal.fire({
                icon: 'error',
                title: 'Ошибка',
                html: err.message
              })
            })
        }
      })
    },
    cancelConfigChanges () {
      this.config = this.prevConfig
      this.isEditing = false
    },
    updateConfig () {
      if (this.isUpdating) {
        return
      }
      this.isUpdating = true

      ConfigsAPI.updateItem(this.config)
        .then(config => {
          this.config = { ...this.config, ...config.model }
          this.isUpdating = false
          this.isEditing = false
        })
        .catch(err => {
          console.error(err)
          this.isUpdating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: err.message
          })
        })
    },
  }
}
</script>
